import React from 'react';
import { Users, ThumbsUp, Droplets } from 'lucide-react';
import "../styles/Offers.css";

const OffersSection = () => {
  // Offer data
  const offers = [
    {
      id: 1,
      discount: '20%',
      condition: 'If you recommend us',
      image: 'images/offer1.jpg',
      icon: <ThumbsUp size={26} aria-hidden="true" />,
      description: 'Get a 20% discount on your next cleaning service when you refer a friend who books with us!'
    },
    {
      id: 2,
      discount: '10%',
      condition: 'On your first cleaning',
      image: 'images/offer2.jpg',
      icon: <Droplets size={26} aria-hidden="true" />,
      description: 'New customers receive 10% off their first booking with our professional cleaning team!'
    }
  ];

  return (
    <section className="sec sec--navy" id='Offers'>
      <div className="container">
        <div className="sec-head sec-head--center">
          <span className="eyebrow">Current offers</span>
          <h2 className="sec-title">Two discounts, no fine print</h2>
          <p className="sec-lede">
            Mention either one when you book and we apply it to your invoice.
          </p>
        </div>

        <div className="offers-grid">
          {offers.map((offer) => (
            <article className="coupon" key={offer.id}>
              <div className="coupon__stub">
                <div>
                  <span className="coupon__kicker">Now available</span>
                  <span className="coupon__amount">{offer.discount}</span>
                  <span className="coupon__condition">{offer.condition}</span>
                </div>
                <div className="coupon__seal">{offer.icon}</div>
              </div>

              <div className="coupon__media">
                <img
                  src={offer.image}
                  alt={`${offer.discount} discount offer`}
                  loading="lazy"
                />
                <p className="coupon__reveal">{offer.description}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="offers-note">
          <span className="chip chip--sun">Limited time only</span>
          <h3>Book now and mention these offers to our team</h3>
          <span className="offers-note__meta">
            <Users size={18} aria-hidden="true" />
            Over 2,000 satisfied customers this year
          </span>
        </div>
      </div>
    </section>
  );
}

export default OffersSection;
